<script setup>
import { useSetThemeColor } from '@/composables/actions';
import Nav from '@/views/_partials/Nav.vue';

defineProps({
    routeBind: Object,
});

useSetThemeColor();
</script>

<style lang="postcss">
body {
    @apply overflow-hidden;
}
.app-view {
    @apply flex flex-row w-full h-screen overflow-hidden gap-4 min-w-0;

    @screen md {
        @apply px-4 pt-10;
    }

    @screen lg {
        @apply px-10;
    }
}
</style>

<template>
    <div class="app-view">
        <Nav v-if="$store.state.deviceType !== 'mobile' || $route.meta.showNav" :is-collapsed="true" />
        <router-view v-slot="{ Component, route }">
            <Component :is="Component" v-bind="routeBind" :key="typeof route.meta.componentKey !== 'undefined' ? route.params[route.meta.componentKey] : undefined" />
        </router-view>
        <router-view name="PostMedia" />
    </div>
</template>
